import { render, staticRenderFns } from "./JobKanbanPage.vue?vue&type=template&id=e9fb26f2&scoped=true"
import script from "./JobKanbanPage.vue?vue&type=script&lang=js"
export * from "./JobKanbanPage.vue?vue&type=script&lang=js"
import style0 from "./JobKanbanPage.vue?vue&type=style&index=0&id=e9fb26f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9fb26f2",
  null
  
)

export default component.exports